(() => {
  const PAGE_CLASS = 'en-article-guide-page';

  const applyArticleCanvas = root => {
    const canvas = '#f5f5f5';
    document.documentElement.style.setProperty('background-color', canvas, 'important');
    document.documentElement.style.setProperty('--gds-shell', canvas, 'important');
    if (document.body) {
      document.body.style.setProperty('background-color', canvas, 'important');
      document.body.style.setProperty('background-image', 'none', 'important');
      document.body.style.setProperty('--gds-shell', canvas, 'important');
    }

    const main = document.querySelector('#MainContent');
    const layout = document.querySelector('.content-for-layout');
    const articleSection = root?.closest('.section-main-article') || root?.closest('.shopify-section');
    const articleGradient = articleSection?.querySelector(':scope > .gradient');
    const articleTemplate = root?.closest('.article-template__article') || articleSection?.querySelector('.article-template__article');

    [layout, main, articleSection, articleGradient, articleTemplate].filter(Boolean).forEach(el => {
      el.style.setProperty('background-color', canvas, 'important');
      el.style.setProperty('background-image', 'none', 'important');
      el.style.setProperty('--gds-shell', canvas, 'important');
    });

    root?.style.setProperty('background-color', 'transparent', 'important');
    root?.querySelector('.article-guide__read')?.style.setProperty('background-color', '#ffffff', 'important');
    root?.querySelector('.article-guide__read')?.style.setProperty('background-image', 'none', 'important');
    root?.querySelector('.article-guide__rail')?.style.setProperty('background-color', '#ffffff', 'important');
    root?.querySelector('.article-guide__rail')?.style.setProperty('background-image', 'none', 'important');
    root?.querySelector('.article-guide__share')?.style.setProperty('background-color', '#ffffff', 'important');

    main?.querySelectorAll(':scope > .shopify-section').forEach(section => {
      if (section.classList.contains('section-article-comments') || section.classList.contains('section-newsletter')) return;
      section.style.setProperty('background-color', canvas, 'important');
      section.style.setProperty('background-image', 'none', 'important');
      section.style.setProperty('--gds-shell', canvas, 'important');
    });
  };

  const init = () => {
    document.documentElement.classList.add(PAGE_CLASS);
    document.body?.classList.add(PAGE_CLASS);

    document.querySelectorAll('[data-article-guide]').forEach(root => {
      applyArticleCanvas(root);
      if (root.dataset.guideReady) return;
      root.dataset.guideReady = 'true';

      const content = root.querySelector('[data-guide-content]');
      if (!content) return;

      content.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(heading => {
        if (!heading.textContent.trim()) heading.replaceWith(...heading.childNodes);
      });
      content.querySelectorAll('a[target="_blank"]').forEach(link => {
        link.relList.add('noopener', 'noreferrer');
      });

      content.querySelectorAll('table').forEach(table => {
        if (table.parentElement?.classList.contains('article-guide__table-wrap')) return;
        const wrap = document.createElement('div');
        wrap.className = 'article-guide__table-wrap';
        wrap.tabIndex = 0;
        table.before(wrap);
        wrap.append(table);
      });

      const nav = root.querySelector('[data-guide-nav]');
      const list = root.querySelector('[data-guide-links]');
      const h2s = [...content.querySelectorAll('h2')].filter(h => h.textContent.trim() && !h.closest('.article-guide__products'));
      const headings = h2s.length ? h2s : [...content.querySelectorAll('h3')].filter(h => h.textContent.trim() && !h.closest('.article-guide__products'));

      const links = headings.map((heading, i) => {
        if (!heading.id) heading.id = root.id + '-part-' + i;
        const li = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'no-scroll';
        link.href = '#' + heading.id;
        link.textContent = heading.textContent;
        link.addEventListener('click', () => {
          heading.tabIndex = -1;
          requestAnimationFrame(() => heading.focus({ preventScroll:true }));
        });
        li.append(link);
        list?.append(li);
        return link;
      });

      if (nav) nav.hidden = !headings.length;

      let queued = false;
      const update = () => {
        queued = false;
        const header = document.querySelector('.section-header');
        const announcement = document.querySelector('.section-announcement-bar');
        const offset = Math.max(
          0,
          header?.getBoundingClientRect().bottom || 0,
          announcement?.getBoundingClientRect().bottom || 0
        ) + 24;

        root.style.setProperty('--guide-offset', offset + 'px');
        let active = 0;
        headings.forEach((heading, i) => {
          if (heading.getBoundingClientRect().top <= offset + 60) active = i;
        });
        links.forEach((link, i) => {
          if (i === active) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      };
      const schedule = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(update);
      };
      window.addEventListener('scroll', schedule, { passive:true });
      window.addEventListener('resize', schedule);
      update();

      const dialog = root.querySelector('dialog');
      let opener = null;
      if (dialog && typeof dialog.showModal === 'function') {
        root.querySelectorAll('[data-guide-open]').forEach(button => {
          button.hidden = false;
          button.addEventListener('click', () => {
            opener = button;
            dialog.showModal();
            document.body.classList.add('article-guide-modal-open');
          });
        });
        root.querySelector('[data-guide-close]')?.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => {
          const rect = dialog.getBoundingClientRect();
          if (
            event.target === dialog &&
            (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)
          ) dialog.close();
        });
        dialog.addEventListener('close', () => {
          document.body.classList.remove('article-guide-modal-open');
          opener?.focus({ preventScroll:true });
        });
      }

      const main = document.querySelector('#MainContent');
      const comments = main?.querySelector('.section-article-comments');
      const newsletter = main?.querySelector('.section-newsletter');

      if (comments && newsletter) {
        let closing = main.querySelector('.article-guide-closing');
        if (!closing) {
          closing = document.createElement('div');
          closing.className = 'article-guide-closing';
          comments.before(closing);
        }
        if (comments.parentElement !== closing) closing.append(comments);
        if (newsletter.parentElement !== closing) closing.append(newsletter);

        comments.style.setProperty('align-self', 'stretch', 'important');
        comments.style.setProperty('height', 'auto', 'important');
        newsletter.style.setProperty('align-self', 'stretch', 'important');
        newsletter.style.setProperty('height', 'auto', 'important');
        [comments.querySelector(':scope > .gradient'), newsletter.querySelector(':scope > .gradient'), newsletter.querySelector('.section__inner'), newsletter.querySelector('.banner'), newsletter.querySelector('.banner__content')].filter(Boolean).forEach(el => {
          el.style.setProperty('height', '100%', 'important');
          el.style.setProperty('min-height', '100%', 'important');
        });

        // EN_ARTICLE_GUIDE_AZ_INPUTS_20261016: preserve English labels outside Azerbaijani pages.
        const isAz = /^az(?:-|$)/i.test(document.documentElement.lang || '');
        const author = comments.querySelector('input[name="comment[author]"]');
        const email = comments.querySelector('input[name="comment[email]"]');
        const body = comments.querySelector('textarea[name="comment[body]"]');
        if (author) {
          author.placeholder = isAz ? 'Ad *' : 'Name *';
          author.setAttribute('aria-label', isAz ? 'Ad' : 'Name');
        }
        if (email) {
          email.placeholder = isAz ? 'E-poçt *' : 'Email *';
          email.setAttribute('aria-label', isAz ? 'E-poçt' : 'Email');
        }
        if (body) {
          body.placeholder = isAz ? 'Şərh *' : 'Comment *';
          body.setAttribute('aria-label', isAz ? 'Şərh' : 'Comment');
        }

        const newsletterEmail = newsletter.querySelector('input[type="email"]');
        if (newsletterEmail) {
          newsletterEmail.placeholder = isAz ? 'E-poçt ünvanı *' : 'Email address *';
          newsletterEmail.setAttribute('aria-label', isAz ? 'E-poçt ünvanı' : 'Email address');
        }

        const subscribeButton = newsletter.querySelector('.newsletter-form__button');
        if (subscribeButton) {
          subscribeButton.setAttribute('aria-label', isAz ? 'Abunə olun' : 'Subscribe');
          subscribeButton.replaceChildren();
          const label = document.createElement('span');
          label.className = 'article-guide-subscribe-label';
          label.textContent = isAz ? 'Abunə olun' : 'Subscribe';
          const arrow = document.createElement('span');
          arrow.className = 'article-guide-subscribe-arrow';
          arrow.setAttribute('aria-hidden', 'true');
          arrow.textContent = '→';
          subscribeButton.append(label, arrow);
        }

        applyArticleCanvas(root);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once:true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();